import React, { useState } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import { useFormik } from 'formik';
import * as yup from 'yup';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Input from '../../components/Input/Input';
import { cpfMask } from '../../shared/masks';
import { Stack } from '@mui/material';
import GestorBlue from '../../assets/images/Icone-Empresa_Azul.png';
import GestorWhite from '../../assets/images/Icone-Empresa_Branco.png';
import EmployeeWhite from '../../assets/images/Icone-Funcionario_Branco.png';
import EmployeeBlue from '../../assets/images/Icone-Funcionario_Azul.png';

const styles = (theme => ({
  button: {
    borderRadius: '100px',
    margin: theme.spacing(2),
    padding: `${theme.spacing(2)}px ${theme.spacing(6)}px`,
  },
  link: {
    display: 'block',
    color: theme.palette.text.secondary,
    textDecoration: 'none',
    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
}));

const LoginForm = (props) => {
  const { classes, loading, isGestor, setIsGestor } = props;

  const [multiProfile, setMultiProfile] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [token, setToken] = useState('');

  const redirectAfterAuth = () => {
    props.history.push(`${props.route === 'assinatura' ? '/assinatura' : '/'}`);
  };

  const formFields = [
    {
      elementType: 'input',
      config: {
        type: 'text',
        name: 'email',
        label: 'Email',
      },
      helperText: ' ',
    },
    {
      elementType: 'input',
      config: {
        type: 'password',
        name: 'password',
        label: 'Senha',
      },
      helperText: ' ',
    },
  ];

  if (props.isEmployee) {
    formFields[0] = {
      elementType: 'maskedInput',
      config: {
        type: 'text',
        name: 'cpf',
        label: 'CPF',
        mask: cpfMask,
      },
      helperText: ' ',
    };
  }

  const formik = useFormik({
    initialValues: {
      email: '',
      password: '',
      cpf: '',
      company: '',
    },
    validationSchema: () =>
      yup.lazy(() => {
        const rules = {};
        if (!multiProfile) {
          rules.password = yup.string().required();
          if (props.isEmployee) {
            rules.cpf = yup.string().required();
          } else {
            rules.email = yup.string().email().required();
          }
        }

        if (multiProfile) {
          rules.company = yup.string().required();
        }

        return yup.object().shape(rules);
      }),
    onSubmit: (values) => {
      if (props.isEmployee) {
        props
          .authEmployee({
            cpf: values.cpf.replace(/\D+/g, ''),
            password: values.password,
          })
          .then(() => props.history.push('/'));
      } else if (multiProfile) {
        props
          .onAuth({ companySelected: values.company, token }, true)
          .then(redirectAfterAuth);
      } else {
        props
          .onAuth(values, true)
          .then((result) => {
            const hasMultiProfile =
              result.companies && result.companies.length > 1;
            if (hasMultiProfile) {
              setToken(result.token);
              setCompanies(result.companies);
              setMultiProfile(!multiProfile);
            } else {
              redirectAfterAuth();
            }
          })
          .catch((error => error));
      }
    },
  });



  return (
    <>
      {
        !multiProfile && (

          <Stack direction="row" spacing={2}>
            {
              props.isEmployee ?
                null
                :
                <>
                  <Button
                    style={{
                      width: '50%',
                      height: '100px',
                      borderRadius: '10px',
                      backgroundColor: !isGestor ? 'white' : '#4651e6',
                      border: '2px solid #eff0f1',
                      color: !isGestor ? '#6f757c' : 'white',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                    onClick={() => setIsGestor(true)}
                  >
                    {isGestor ? (
                      <div style={{ marginBottom: '-10px', marginTop: '20px' }}>
                        <img
                          alt="icon"
                          src={GestorWhite}
                          style={{
                            width: '40px',
                            height: '40px',
                          }}
                        />
                        <p>Empresa</p>
                      </div>
                    ) : (
                      <div style={{ marginBottom: '-10px', marginTop: '20px' }}>
                        <img
                          alt="icon"
                          src={GestorBlue}
                          style={{
                            width: '40px',
                            height: '40px',
                          }}
                        />
                        <p>Empresa</p>
                      </div>
                    )}

                  </Button>


                  <Button
                    style={{
                      width: '50%',
                      height: '100px',
                      borderRadius: '10px',
                      border: '2px solid #eff0f1',
                      backgroundColor: 'white',
                      color: '#6e747b',
                      fontWeight: 'bold',
                      // display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                    onClick={() => window.location.href = 'https://app.puntu.digital/login/funcionario'}
                  >
                    <div style={{ marginBottom: '-10px', marginTop: '20px' }}>
                      <img
                        alt="icon"
                        src={EmployeeBlue}
                        style={{
                          width: '40px',
                          height: '40px',
                        }}
                      />
                      <p>Funcionário</p>
                    </div>
                  </Button>
                </>
            }
          </Stack>
        )
      }
      {
        isGestor || props.isEmployee ?

          <form onSubmit={formik.handleSubmit}>
            {!multiProfile &&
              formFields.map(field => (
                <Input
                  key={field.index}
                  {...field.config}
                  elementType={field.elementType}
                  value={formik.values[field.config.name]}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  required
                  fullWidth
                  margin="normal"
                  error={
                    formik.errors[field.config.name] &&
                    formik.touched[field.config.name]
                  }
                  helperText={
                    (formik.touched[field.config.name] &&
                      formik.errors[field.config.name]) ||
                    field.helperText
                  }
                />
              ))}
            {multiProfile && (
              <>
                <Typography align="left" color="textSecondary">
                  Você possui multiplos perfis. Escolha um para continuar!
                </Typography>
                <Input
                  elementType="select"
                  value={formik.values.company}
                  name="company"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  label="Escolha uma empresa"
                  required
                  fullWidth
                  margin="normal"
                  options={companies.map(item => ({
                    value: item.companyId,
                    displayValue: item.companyName,
                  }))}
                  error={formik.errors.company}
                  helperText={formik.errors.company}
                />
              </>
            )}

            <Typography variant="caption" align="right">
              <Link to="/esqueceu-senha" className={classes.link}>
                esqueceu sua senha?
              </Link>
            </Typography>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              className={classes.button}
              disabled={loading}
            >
              {loading ? (
                <CircularProgress size={20} color="primary" />
              ) : (
                `${multiProfile ? 'CONTINUAR' : 'ENTRAR'}`
              )}
            </Button>
          </form>
          :
          null
      }
    </>
  );
};

export default withRouter(withStyles(styles)(LoginForm));
